import gcodePane from './gcode-pane';
import controlsOverlay from './controls-overlay';

export default {
  ui: {
    ...gcodePane.ui,
    ...controlsOverlay.ui
  }
};
